/* eslint-disable import/prefer-default-export */
import { useQuery } from '@tanstack/react-query';
import { APIKey, apiRoutes } from 'constants/apiKeys';
import baseFetcher from 'shared/helpers/baseFetcher';
import { OverviewNumbers } from 'dashboard/types';

export function useOverviewNumbers(queryParams: string) {
  return useQuery<OverviewNumbers>({
    queryKey: [APIKey.OVERVIEW_NUMBERS, queryParams],
    queryFn: () => baseFetcher(`${apiRoutes.overviewNumbers()}?${queryParams}`),
  });
}
